import React, { useMemo } from "react";
import Stats from "../Quants.js/Stats";
import BoxBreakStats from "../Quants.js/BoxBreakStats";
import useAnalyticsData from "./Hooks/useAnalyticsData";
import AnalyticsPageHeader from "./AnalyticsPageHeader";
import AnalyticsFilterBar from "./AnalyticsFilterBar";
import { FaBoxOpen, FaShoppingCart, FaLayerGroup } from "react-icons/fa";

const BoxBreakAnalytics = () => {
  const {
    analyticsData,
    date,
    today,
    isFilterApplied,
    handleStartDateChange,
    handleEndDateChange,
    fetchData,
  } = useAnalyticsData();

  const bb = analyticsData?.box_break;

  const boxTopStats = useMemo(
    () => [
      {
        label: "Total Products",
        icon: <FaBoxOpen />,
        value: bb?.total_box_break_products || 0,
        color: "#6C63FF",
      },
      {
        label: "Total Orders",
        icon: <FaShoppingCart />,
        value: bb?.total_box_break_orders || 0,
        color: "#2196F3",
      },
      {
        label: "Total Categories",
        icon: <FaLayerGroup />,
        value: bb?.total_box_break_categories || 0,
        color: "#00A86B",
      },
    ],
    [bb]
  );

  return (
    <div className="container-fluid py-4">
      <AnalyticsPageHeader
        theme="box"
        icon={<FaBoxOpen />}
        title="Box Break Analytics"
        subtitle="Track products, orders and categories across box break events"
      />

      <AnalyticsFilterBar
        date={date}
        today={today}
        isFilterApplied={isFilterApplied}
        onStartDateChange={handleStartDateChange}
        onEndDateChange={handleEndDateChange}
        onApply={fetchData}
      />

      {/* Top Cards */}
      <Stats topStats={boxTopStats} />
      <BoxBreakStats analyticsData={analyticsData} />
    </div>
  );
};

export default BoxBreakAnalytics;
